'use strict';

var incomingData = {};
angular.module('widgets.controltower', ['adf.provider', 'embeddedMetricCharts', 'sharedInitiatives'])

	.config(function (dashboardProvider, $uibTooltipProvider) {
		var widgetControlTower = {
			name: 'Control tower',
			description: 'Control tower',
			thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/table.png',
			categories: [],
			config: {},
			slideshowView: true,
			isActive: true,
			templateUrl: '/application/f/dashboard/widgets/control_tower.html',
			reload: true,
			isDrillDown: false,
			nonRemovable: true
		};
		// register Control Tower Widgets
		dashboardProvider
			.widget('controlTower', angular.extend({
				controller: 'controlTowerCtrl'
			}, widgetControlTower));

		$uibTooltipProvider.setTriggers({
			'showMetricResults': 'hideMetricResults'
		});
	})

	.directive('resizeControlTower', function ($window, $timeout) {
		return {
			link: function (scope, element, attr) {
				var w = angular.element($window);
				var minWidth = 43;
				var maxWidth = 133;
				var navOpen = !jQuery('#sidebarCell').hasClass('sidebarCollapsed');
				var sidebarWidth = jQuery('#sidebarCell').width();
				var offset = jQuery('body').width() - jQuery(element).width() - 10;
				var panelBodyParent = jQuery(element).parents('.panel-body').width();
				scope.resizeCT = function () {
					var numberOfMetrics = scope.metrics.length > scope.METRIC_LIMIT ? scope.METRIC_LIMIT : scope.metrics.length;
					jQuery(element).parents('.panel-body').css('padding', 0);
					var width = 100 / (numberOfMetrics * scope.colSpanLength + 2);
					var widthType = '%';
					var tableWidth = jQuery(element).width();
					var tableParentWidth = jQuery(element).parent().width();
					var bodyWidth = jQuery('body').width();
					var navOpenChange = !jQuery('#sidebarCell').hasClass('sidebarCollapsed');
					panelBodyParent = jQuery(element).parents('.panel-body').width();
					if (navOpenChange !== navOpen) {
						if (navOpen) {
							offset = offset - sidebarWidth;
						} else {
							offset = offset + sidebarWidth;
						}
						navOpen = navOpenChange;
					}
					if (width / 100 * tableParentWidth < minWidth) {
						if (jQuery(element).hasClass('notFull')) {
							jQuery(element).removeClass('notFull');
						}
						width = minWidth;
						widthType = 'px';
						var val = bodyWidth - offset > panelBodyParent ? panelBodyParent : bodyWidth - offset;
						jQuery(element).width(val);
						jQuery(element).children('.controlTower').width(minWidth * (numberOfMetrics * scope.colSpanLength + 2));
					} else if (width / 100 * (bodyWidth - offset) > maxWidth) {
						if (!jQuery(element).hasClass('notFull')) {
							jQuery(element).addClass('notFull');
						}
						width = maxWidth;
						widthType = 'px';
						jQuery(element).children('.controlTower').width(maxWidth * (numberOfMetrics * scope.colSpanLength + 2));
					} else {
						if (jQuery(element).hasClass('notFull')) {
							jQuery(element).removeClass('notFull');
						}
						width = 100 / (numberOfMetrics * scope.colSpanLength + 2);
						widthType = '%';
						jQuery(element).css('width', '');
						jQuery('.controlTower').css('width', '');
					}
					scope.widthValue = width + widthType;
				};

				scope.resizeCT();

				w.bind('resize', function () {
					scope.resizeCT();
					scope.$apply();
				});

				scope.$on('sideBarUpdate', function (event, name, model) {
					$timeout(function () {
						scope.resizeCT();
					}, 0);
				});
			}
		};
	})

	.controller('controlTowerCtrl', function ($rootScope, $scope, $sce, $timeout,
		$uibModal, $filter, $translate, config, dashboardFilterInitializationService, 
		currencyFormatService, slideInModalService, numberFormatService, controlTowerService, 
		pageTimingService, metricRoundingService, leanFilterService, storeService, tableService) {
		$scope.metricLabel = 'Metric';
		$scope.metrics = [];
		$scope.metricHeaders = [];
		$scope.metricValues = [];
		$scope.categories = [];
		$scope.selectedRow = '';
		$scope.empty = true;
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.modelDetails = $scope.$parent.model;
		$scope.toggleColumn = toggleColumn;
		$scope.METRIC_LIMIT = 50;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		$scope.metricOwnerLabel = $translate.instant('Metric Owner');
		var configStr = $scope.modelDetails.config;

		// Add class for control-tower
		jQuery('.embeddedBody').addClass('control-tower');

		// Load the saved columns in case of widget reload.
		if (config.columns) {
			configStr.columns = config.columns;
		}

		setControlTowerDefaultColumns(configStr);
		updateControlTowerByColumns();
		var heavyBorderMap = {};
		var goalMap = {};
		var crossSiteNameMap = {};
		var categoryMap = {};
		var opened = false;
		var serviceMap = {
			'currency': currencyFormatService,
			'number': numberFormatService,
			'percentage': numberFormatService,
			'float': numberFormatService
		};
		var hierarchyMap = {
			'byEntity': {},
			'byDivision': {},
			'byBusinessUnit': {}
		};
		var metricOwnerToMetricName = {};

		$scope.selectRow = function (row) {
			$scope.selectedRow = row;
		};

		$scope.checkForYtd = function (month) {
			return (typeof (month) === 'string' &&
				month.toLowerCase() === 'ytd');
		};

		$scope.formatPeriod = function (period, year, date, isDrilldown) {
			// convert fiscal to calendar
			if ($scope.type === 'Monthly') {
				// monthly control tower
				var calendarMonth = parseInt(period) + $scope.startMonthOfYear - 1;
				if ($scope.startMonthOfYear !== 1) {
					year -= 1;
				}
				if (calendarMonth > 12) {
					calendarMonth -= 12;
					year += 1;
				}
				if (calendarMonth < 10) {
					calendarMonth = '0' + calendarMonth;
				}
				return $filter('date')(year + '-' + calendarMonth + '-15', isDrilldown ? 'yyyy-MM-dd': 'MMM-yyyy', 'UTC');
			} else {
				// weekly
				return $filter('date')(date, 'yyyy-MM-dd', 'UTC');
			}
		};

		$scope.formatDate = function (timestamp) {
			return $filter('date')(timestamp, 'MMM dd', 'UTC');
		};

		$scope.checkForHeavyBorder = function (metricName, metName) {
			return heavyBorderMap[metName + '-' + metricName] ||
				heavyBorderMap[metricName];
		};

		$scope.showIt = function(parentIndex, childNdx) {
			$timeout(function () {
				var element = '#controlTowerCell' + parentIndex + '_' + childNdx;
				var elementOffSet = jQuery(element).offset();
				if (element.length && elementOffSet) {
					var elementVerticalPosition = elementOffSet.top - jQuery(document).scrollTop();
					var halfScreen = window.outerWidth / 2;
					var tooltipPosition = 'left';
					if (elementOffSet.left < halfScreen) {
						tooltipPosition = 'right';
					} else {
						tooltipPosition= 'left';
					}
	
					if (elementVerticalPosition > window.innerHeight / 2) {
						if (tooltipPosition == 'right') {
							tooltipPosition = 'top-left';
						} else {
							tooltipPosition = 'top-right';
						}
					}
					$scope.tooltipPlacement = tooltipPosition;
					jQuery(element).trigger('showMetricResults');
				}
			});
		};

		$scope.hideIt = function (parentIndex, childNdx) {
			$timeout(function () {
				jQuery('#controlTowerCell' + parentIndex + '_' + childNdx).trigger('hideMetricResults');
			});
		};

		$scope.showDiffTooltip = function(diffVal, diffArrow) {
			return (typeof diffVal !== 'undefined' && typeof diffArrow === 'undefined') ? true : false;
		};

		$scope.getMetricOwnerTooltip = function (metricName) {
			if ($scope.categoryLabel === 'Metric' && metricOwnerToMetricName[metricName]) {
				return _.uniq(metricOwnerToMetricName[metricName]).toString();
			}
			return null;
		};
	
		$scope.openModalReport = function (metric, useMetName, factoryNdx) {
			var reportScope = $scope.$new();
			reportScope.isEmbedded = true;
			incomingData.supplierNdxs = null;
			delete incomingData.supplierNdxs;
			incomingData.metricNdx = metric.ndx;
			incomingData.vsNdx = metric.valuestreamNdx;
			incomingData.beginDate = $scope.startDate;
			incomingData.endDate = $scope.endDate;
			incomingData.metricName = useMetName ? metric.metName : metric.name;
			incomingData.crossSiteName = crossSiteNameMap[metric.name];
			incomingData.vsList = $scope.filterService.getSelected('Value Stream');
			incomingData.initVsList = $scope.filterService.getSelected('Value Stream');
			var selectedFactories = $scope.filterService.getSelected('Factory');
			incomingData.factory = useMetName ? factoryNdx : selectedFactories;
			if (selectedFactories.length > 1) {
				incomingData.currency = $scope.currency;
			}
			reportScope.selectedVstreamNames = $scope.leanFilterService.getSelectedLabels('valueStream').toString();
			reportScope.mtrcName = useMetName ? metric.metName : metric.name;
			if (!reportScope.selectedVstreamNames || reportScope.selectedVstreamNames === '') {
				reportScope.selectedVstreamNames = 'Plant Wide';
			}
			var instance = $uibModal.open({
				scope: reportScope,
				templateUrl: '/application/f/dashboard/widgets/a3metric.html',
				windowTemplateUrl: '/application/f/dashboard/widgets/a3metric-template.html'
			});

			instance.result.then(function () {
				// do nothing on success
			}, function () {
				reportScope.closeDialog();
			});

			reportScope.closeDialog = function () {
				incomingData = {};
				instance.close();
				reportScope.$destroy();

			};
		};

		function getGoalClass(type, act, goal) {
			// account for small discrepancies like floating point errors
			var absGoal = Math.abs(goal);
			var tinyFractionOfGoal = 0.00001;
			if (absGoal < 1) {
				tinyFractionOfGoal *= absGoal;
			}
			var goalClass = '';
			if (type.toLowerCase() === 'below') {
				if (act <= goal + tinyFractionOfGoal) {
					goalClass = 'goodCell';
				} else if (act <= goal + absGoal * 0.1) {
					goalClass = 'warningCell';
				} else {
					goalClass = 'badCell';
				}
			} else {
				if (act >= goal - tinyFractionOfGoal) {
					goalClass = 'goodCell';
				} else if (act >= goal - absGoal * 0.1) {
					goalClass = 'warningCell';
				} else {
					goalClass = 'badCell';
				}
			}
			return goalClass;
		}

		function formatData() {
			angular.forEach($scope.metricValues, function (mv, arrayIndex) {
				for (var key in mv) {
					if (key !== 'period' && key !== 'year' && key !== 'date') {
						var met = {};
						for (var i = 0; i < $scope.metrics.length; i++) {
							if ($scope.metrics[i].name === key ||
								$scope.metrics[i].metName + '-' + $scope.metrics[i].name === key) {
								met = $scope.metrics[i];
								break;
							}
						}
						var fmtService = serviceMap[met.displayType];
						// add the goal class to the data before I format it
						var goalType = met.goal;
						if (goalType && mv[key].act !== null && mv[key].goal !== null) {
							var goalClass = getGoalClass(goalType, mv[key].act, mv[key].goal);
							mv[key].goalClass = goalClass;
						}
						if (fmtService) {
							var unitSymbol = '';
							if (met.displayType === 'percentage') {
								unitSymbol = '%';
							}
							mv[key].rawAct = mv[key].act;
							if (typeof mv[key].act !== undefined && mv[key].act !== null) {
								if (arrayIndex > 0) {
									var lastActualValue = $scope.metricValues[arrayIndex - 1][key];
									if(typeof lastActualValue.act !== undefined && lastActualValue.act !== null) {
										var diff = mv[key].act - lastActualValue.rawAct;
										mv[key].dif = diff;
										if ((Math.abs(diff) / Math.abs(lastActualValue.rawAct) )* 100 >= 0.25 ) {
											if (mv[key].dif > 0) {
												mv[key].arrow = 'up';
												mv[key].difClass = goalType.toLowerCase() === 'below' ? 'down' : 'up';
											} else if (mv[key].dif < 0) {
												mv[key].arrow = 'down';
												mv[key].difClass = goalType.toLowerCase() === 'below' ? 'up' : 'down';
											}
										}

										if (met.displayType === 'currency') {
											mv[key].dif = fmtService.get(mv[key].dif, $scope.currencySymbol);
										} else {
											mv[key].dif = fmtService.get(mv[key].dif) + unitSymbol;
										}
									}
								}
								var keepAllDecimals = met.valueFunction === 'value';
								if (met.displayType === 'currency') {
									mv[key].actualAllDecimals = (mv[key].act || mv[key].act === 0) 
										? fmtService.getWithParameters(mv[key].act, Math.max(numberOfDecimals(mv[key].act, 0, keepAllDecimals), 2), $scope.currencySymbol)
										: undefined;
									mv[key].act = fmtService.get(mv[key].act, $scope.currencySymbol);
								} else {
									mv[key].actualAllDecimals = (mv[key].act || mv[key].act === 0) 
										? fmtService.getWithParameters(mv[key].act, numberOfDecimals(mv[key].act, 0, keepAllDecimals)) + unitSymbol
										: undefined;
									mv[key].act = fmtService.get(mv[key].act) + unitSymbol;
								}
							}
							if (typeof mv[key].goal !== undefined && mv[key].goal !== null) {
								if (met.displayType === 'currency') {
									mv[key].goalAllDecimals = (mv[key].goal || mv[key].goal === 0) 
										? fmtService.getWithParameters(mv[key].goal, Math.max(numberOfDecimals(mv[key].goal, 0, true), 2), $scope.currencySymbol)
										: undefined;
									mv[key].goal = fmtService.get(mv[key].goal, $scope.currencySymbol);
								} else {
									mv[key].goalAllDecimals = (mv[key].goal || mv[key].goal === 0) 
									 ? fmtService.getWithParameters(mv[key].goal, numberOfDecimals(mv[key].act, 0, true)) + unitSymbol
									 : undefined;
									mv[key].goal = fmtService.get(mv[key].goal) + unitSymbol;
								}
							}
						}
					}
				}
			});

			for (var i = 0; i < $scope.metrics.length; i++) {
				var fmtService = serviceMap[$scope.metrics[i].displayType];
				if (fmtService && typeof $scope.metrics[i].fyTarget !== undefined && $scope.metrics[i].fyTarget !== null) {
					if ($scope.metrics[i].displayType === 'currency') {
						$scope.metrics[i].fyTarget = fmtService.get($scope.metrics[i].fyTarget, $scope.currencySymbol);
					} else {
						$scope.metrics[i].fyTarget = fmtService.get($scope.metrics[i].fyTarget) +
							($scope.metrics[i].displayType === 'percentage' ? '%' : '');
					}
				} else {
					$scope.metrics[i].fyTarget = '';
				}
			}
		}

		function extractHeaders() {
			angular.forEach($scope.metrics, function (met) {
				$scope.metricHeaders.push(met.name);
				goalMap[met.name] = met.goal;
				crossSiteNameMap[met.name] = met.crossSiteName;
			});
		}

		function buildCategoryMap() {
			var index = 0;
			angular.forEach($scope.metrics, function (met) {
				if (index < $scope.METRIC_LIMIT) {
					var cat = categoryMap[met.category];
					if (cat) {
						cat.value = cat.value + 1;
					} else {
						categoryMap[met.category] = { 'value': 1 };
					}
				}
				index++;
			});
		}

		function buildCategories() {
			for (var key in categoryMap) {
				if (categoryMap.hasOwnProperty(key)) {
					$scope.categories.push({ 'header': key, 'colspan': categoryMap[key].value });
				}
			}
		}

		function buildHeavyBorderMap() {
			var currentCategory = '';
			angular.forEach($scope.metrics, function (met) {
				if (met.category !== currentCategory) {
					currentCategory = met.category;
					heavyBorderMap[met.name] = true;
				}
			});
		}

		function organizeCTData(data) {
			var result = {};
			result.startMonthOfYear = data[0].startMonthOfYear;
			var metricFactoryCount = {};
			var metricCategory = {};
			var metricNameToCategory = {};
			var i, j, k;
			var metricName;

			// count the number of sites per metric
			for (i = 0; i < data.length; i++) {
				var siteMetrics = data[i].metrics;

				for (j = 0; j < siteMetrics.length; j++) {
					metricName = siteMetrics[j].name;

					if (!metricFactoryCount[metricName]) {
						metricFactoryCount[metricName] = 0;
					}
					metricFactoryCount[metricName] += 1;

					// correct for metrics that are in different categories at sites
					if (metricNameToCategory[metricName]) {
						// use category of first site that had metric
						siteMetrics[j].category = metricNameToCategory[metricName];
					} else {
						metricNameToCategory[metricName] = siteMetrics[j].category;

						if (!metricCategory[siteMetrics[j].category]) {
							metricCategory[siteMetrics[j].category] = {};
						}

						if (!metricCategory[siteMetrics[j].category][metricName]) {
							metricCategory[siteMetrics[j].category][metricName] = 0;
						}
					}
					metricCategory[siteMetrics[j].category][metricName] += 1;
				}
			}

			var key;
			var categoryCount = 0;
			var categoryKeys = _.keys(metricFactoryCount).sort();
			var topLvlCategories = _.keys(metricCategory).sort();
			var categoryOrder = [];
			
			angular.forEach(topLvlCategories, function(topLvlCategory) {
				categoryOrder = _.concat(categoryOrder, _.keys(metricCategory[topLvlCategory]));
			});
			categoryKeys = categoryOrder;
			$scope.topLvlCategories = [];
			var currentTopLvlCategory = '';
			angular.forEach(categoryKeys, function(key) {
				if (metricFactoryCount.hasOwnProperty(key)) {
					if (categoryCount < $scope.METRIC_LIMIT) {
						var diff = $scope.METRIC_LIMIT - (categoryCount + metricFactoryCount[key]);
						var offset = 0;
						if (diff >= 0) {
							$scope.categories.push({ 'header': key, 'colspan': metricFactoryCount[key] });
							categoryCount += metricFactoryCount[key];
							offset = metricFactoryCount[key];
						} else {
							var newLimit = metricFactoryCount[key] - Math.abs(diff);
							diff = $scope.METRIC_LIMIT - (categoryCount + newLimit);
							if (diff >= 0) {
								$scope.categories.push({ 'header': key, 'colspan': newLimit });
								categoryCount += metricFactoryCount[diff];
								offset = newLimit;
							}
						}

						if (offset !== 0) {
							if (currentTopLvlCategory !== metricNameToCategory[key]) {
								currentTopLvlCategory = metricNameToCategory[key];
								$scope.topLvlCategories.push({ 'header': metricNameToCategory[key], 'colspan': offset });
							} else {
								$scope.topLvlCategories[$scope.topLvlCategories.length - 1]['colspan'] += offset;
							}
						}
					}
				}
			});

			// build metrics and metricValues lists
			result.metricValues = [];
			var metricValuesMap = {};
			var rowcount = data[0].metricValues.length;
			// loop through periods
			for (i = 0; i < rowcount; i++) {
				var obj = {
					period: data[0].metricValues[i].period,
					year: data[0].metricValues[i].year,
					date: data[0].metricValues[i].date
				};

				// loop through sites
				for (j = 0; j < data.length; j++) {
					var factoryName = data[j].metrics[0].factoryName;
					var metricValues = data[j].metricValues[i];

					// loop through metrics
					for (k = 0; k < $scope.categories.length; k++) {
						metricName = $scope.categories[k].header;
						if (metricValues[metricName]) {
							key = metricName + '-' + factoryName;
							obj[key] = metricValues[metricName];
						}
					}
				}
				metricValuesMap[i] = obj;
			}

			for (i = 0; i < rowcount; i++) {
				result.metricValues.push(metricValuesMap[i]);
			}

			result.metrics = [];
			for (i = 0; i < $scope.categories.length; i++) {
				metricName = $scope.categories[i].header;
				if (!metricOwnerToMetricName[metricName]) {
					metricOwnerToMetricName[metricName] = [];
				}
				for (k = 0; k < data.length; k++) {
					var list = data[k].metrics;
					for (j = 0; j < list.length; j++) {
						if (list[j].name === metricName) {
							var metMetaData = list[j];
							metricOwnerToMetricName[metricName].push(metMetaData.metricOwner);
							result.metrics.push({
								'name': metMetaData.factoryName,
								'metName': metricName,
								'ndx': metMetaData.ndx,
								'goal': metMetaData.goal,
								'targetPeriodType': metMetaData.targetPeriodType,
								'fyTarget': metMetaData.fyTarget,
								'dataAggregationTypeForCrossSite': metMetaData.dataAggregationForCrossSite,
								'displayType': metMetaData.displayType,
								'valuestreamNdx': metMetaData.valuestreamNdx,
								'factoryNdx': data[k].siteId,
								'hideLink': metMetaData.factoryName === 'All',
								'metricOwner': metMetaData.metricOwner
							});
							$scope.metricHeaders.push(metricName + '-' + metMetaData.factoryName);
							crossSiteNameMap[metricName + '-' + metMetaData.factoryName] = metMetaData.crossSiteName;
						}
					}
				}
			}

			var currentMetric = '';
			angular.forEach(result.metrics, function (metric) {
				if (metric.metName !== currentMetric) {
					currentMetric = metric.metName;
					heavyBorderMap[metric.metName + '-' + metric.name] = true;
				}
			});

			return result;
		}

		function init() {
			extractHeaders();
			buildCategoryMap();
			buildCategories();
			buildHeavyBorderMap();
			formatData();
			$timeout(function () {
				$scope.resizeCT();
			}, 0);
		}

		function getRawData() {
			$scope.showLinks = true;
			if ($scope.leanFilterService.getFactoryList(true).length > 1) {
				$scope.showLinks = false;
			}

			tableService.trackPageView('control-tower', $scope.leanFilterService.getFactoryList());

			return controlTowerService.getUnaggregatedMetricResults($scope.filterService, true)
				.then(function (data) {
					$scope.rawMetricResults = {};
					$scope.rawMetricResultsCount = {};
					$scope.rawMetricInactiveInterval = data.metricInactiveInterval;
					var results = data.results;
					if (results === undefined) {
						return;
					}

					var multiFactory = $scope.filterService.getSelected('Multi Factory');
					if (!multiFactory) {
						multiFactory = 'combinedOnly';
					}
					for (var i = 0; i < results.length; i++) {
						var metricResult = results[i];
						var metricName = metricResult.name;
						if ($scope.filterService.getSelected('Factory').length > 1 &&
							multiFactory !== 'combinedOnly') {
							var groupName = metricResult.factoryName;
							if (multiFactory !== 'site') {
								for (var j = 0; j < data.siteHierarchy.length; j++) {
									if (data.siteHierarchy[j].factoryAlias === metricResult.factoryName) {
										groupName = data.siteHierarchy[j][multiFactory];
										break;
									}
								}
							}
							metricName += '-' + groupName;
						}
						// create bucket for metric, keyed by name
						if (!(metricName in $scope.rawMetricResults)) {
							$scope.rawMetricResults[metricName] = {};
							$scope.rawMetricResultsCount[metricName] = {};
						}

						// create subbucket for period
						var period;
						if ($scope.type === 'Monthly') {
							period = metricResult.fiscalMonth;
						} else if ($scope.type.endsWith('Weeks')) {
							period = metricResult.fiscalYear.toString();
							if (metricResult.fiscalWeek < 10) {
								period += '0';
							}
							period += metricResult.fiscalWeek.toString();
						}

						if (!(period in $scope.rawMetricResults[metricName])) {
							$scope.rawMetricResults[metricName][period] = [];
							$scope.rawMetricResultsCount[metricName][period] = {
								totalRecords: 0,
								metrics: {}
							};
						}

						// format the value
						var fmtService = serviceMap[metricResult.displayType];
						if (fmtService) {
							var unitSymbol = '';
							if (metricResult.displayType === 'percentage') {
								unitSymbol = '%';
							}
							if (typeof metricResult.value !== undefined && metricResult.value !== null) {
								var decimals = metricRoundingService.getDecimals(metricResult);
								if (metricResult.displayType === 'currency') {
									decimals = Math.max(decimals, 2);
									metricResult.value = fmtService.get(metricResult.value, data.currencySymbol);
								} else {
									metricResult.value = fmtService.get(metricResult.value) + unitSymbol;
								}
							}
						}

						var resultDate = new Date(metricResult.currentDate);
						var result = {
							date: $scope.formatDate(resultDate),
							value: metricResult.value,
							valueStream: metricResult.valueStream,
							factoryName: metricResult.factoryName,
							leanDirFactoryNdx: metricResult.factoryNdx
						};
						if (metricResult.isCategorized) {
							result.category = metricResult.category;
						}
						$scope.rawMetricResults[metricName][period].push(result);
						if (!$scope.rawMetricResultsCount[metricName][period]['metrics'][metricResult.metricNdx]) {
							$scope.rawMetricResultsCount[metricName][period]['totalRecords'] += metricResult.totalResultsForMonth;
							$scope.rawMetricResultsCount[metricName][period]['metrics'][metricResult.metricNdx] = metricResult.totalResultsForMonth;
						}
					}

					results = data.metricInactiveInterval;

					for (var i = 0; i < results.length; i++) {
						var metricResult = results[i];
						var metricName = metricResult.name;
						if ($scope.filterService.getSelected('Factory').length > 1 &&
							multiFactory !== 'combinedOnly') {
							metricName += '-' + metricResult.factoryName;
						}
						// create bucket for metric, keyed by name
						if (!(metricName in $scope.rawMetricResults)) {
							$scope.rawMetricResults[metricName] = {};
							$scope.rawMetricResultsCount[metricName] = {};
						}

						// create subbucket for period
						var period;
						if ($scope.type === 'Monthly') {
							period = metricResult.fiscalMonth;
						} else if ($scope.type.endsWith('Weeks')) {
							period = metricResult.fiscalYear.toString();
							if (metricResult.fiscalWeek < 10) {
								period += '0';
							}
							period += metricResult.fiscalWeek.toString();
						}

						if (!(period in $scope.rawMetricResults[metricName])) {
							$scope.rawMetricResults[metricName][period] = [];
							$scope.rawMetricResultsCount[metricName][period] = {totalRecords: 0};
						}

						metricResult.value = 'N/A';
						var totalRecords = 0;
						var resultDate = new Date(metricResult.endTimestamp);
						var result = {
							date: $scope.formatDate(resultDate),
							value: metricResult.value,
							valueStream: metricResult.valueStream,
							factoryName: metricResult.factoryName,
							leanDirFactoryNdx: metricResult.factoryNdx,
							isInactive: true
						};

						$scope.rawMetricResults[metricName][period].push(result);
						$scope.rawMetricResultsCount[metricName][period]['totalRecords'] += 1;
					}
				});
		}

		function showCategories(metricData) {
			return metricData.filter(function (obj) { return obj.category && typeof obj.category !== 'undefined'; }).length;
		}

		$scope.updateTooltipHtml = function (targetMetricName, period, year, date, actualValueWithAllDecimals) {
			var htmlContent = '';
			if ($scope.rawMetricResults && !$scope.checkForYtd(period)) {
				var multiFactory = $scope.filterService.getSelected('Multi Factory');
				if (!multiFactory) {
					multiFactory = 'combinedOnly';
				}
				var periodName = $scope.formatPeriod(period, year, date);
				var metricData = null;
				var isAllSitesCell = false;
				var totalRecords = 0;
				if (targetMetricName in $scope.rawMetricResults) {
					metricData = $scope.rawMetricResults[targetMetricName][period];
					if ($scope.rawMetricResultsCount[targetMetricName][period] &&
						$scope.rawMetricResultsCount[targetMetricName][period]['totalRecords']) {
						totalRecords = $scope.rawMetricResultsCount[targetMetricName][period]['totalRecords'];
					}

				} else {
					var pos = targetMetricName.indexOf('-All');
					if (pos !== -1 && targetMetricName.length === pos + 4) {
						isAllSitesCell = true;
						// remove the site name from the metric name
						targetMetricName = targetMetricName.substr(0, pos);
						metricData = [];
						// add all the results from different sites to a common list
						for (var metricName in $scope.rawMetricResults) {
							if ($scope.rawMetricResults.hasOwnProperty(metricName) &&
									$scope.rawMetricResults[metricName].hasOwnProperty(period) &&
									(metricName == targetMetricName ||
										metricName.indexOf(targetMetricName) === 0 && metricName[pos] == '-')) {
								metricData = metricData.concat($scope.rawMetricResults[metricName][period]);
								totalRecords += $scope.rawMetricResultsCount[metricName][period]['totalRecords'];
							}
						}
						// sort by date
						metricData.sort(function (a, b) {
							var dateA = new Date(a.date),
								dateB = new Date(b.date);
							return dateA - dateB;
						});
					}
				}

				if (metricData && metricData.length > 0) {
					var columnCount = 2;
					var showValueStream = false;
					var showCategory = false;
					var showFactoryName = false;

					if (metricData[0].valueStream && metricData[0].valueStream !== 'UndefinedValuestream') {
						columnCount += 1;
						showValueStream = true;
					}

					if (metricData[0].hasOwnProperty('category') && showCategories(metricData) > 0) {
						columnCount += 1;
						showCategory = true;
					}

					if ($scope.filterService.getSelected('Factory').length > 1 && (multiFactory !== 'site' ||
							isAllSitesCell)) {
						columnCount += 1;
						showFactoryName = true;
					}

					htmlContent =
						'<table border="2px solid white" style="background-color:black;color:white;">' +
						'<tr>' +
						'<th colspan="' + columnCount + '" style="text-align:center;padding:4px">' + strip(targetMetricName) + '</th>' +
						'</tr>' +
						'<tr>' +
						'<th colspan="' + columnCount + '" style="text-align:center;padding:4px">' + periodName + '</th>' +
						'</tr>' +
						'<tr>' +
						'<th colspan="' + columnCount + '" style="text-align:center;padding:4px">' + actualValueWithAllDecimals + '</th>' +
						'</tr>' +
						'<tr>' +
						'<th style="text-align:center;padding:4px">Date</th>' +
						'<th style="text-align:center;padding:4px">Value</th>';
					if (showValueStream) {
						htmlContent +=
							'<th style="text-align:center;padding:4px">V. Stream</th>';
					}
					if (showCategory) {
						htmlContent +=
							'<th style="text-align:center;padding:4px">Category</th>';
					}
					if (showFactoryName) {
						htmlContent +=
							'<th style="text-align:center;padding:4px">Site</th>';
					}
					htmlContent +=
						'</tr>';

					for (var i = 0; i < totalRecords; i++) {
						// only show 10 records, unless there are just 1-2 more
						if (i < 10 || (totalRecords <= 12 && metricData.length > i)) {
							htmlContent +=
								'<tr>' +
								'<td style="padding:4px;white-space:nowrap;">' + metricData[i].date + '</td>' +
								'<td style="padding:4px">' + metricData[i].value + '</td>';
							if (showValueStream) {
								htmlContent +=
									'<td style="padding:4px">' + (metricData[i].valueStream == 'UndefinedValuestream' ? 'Plant Wide' : strip(metricData[i].valueStream)) + '</td>';
							}
							if (showCategory) {
								htmlContent +=
									'<td style="padding:4px">' + (typeof metricData[i].category !== 'undefined' ? strip(metricData[i].category) : '') + '</td>';
							}
							if (showFactoryName) {
								htmlContent +=
									'<td style="padding:4px;white-space:nowrap;">' + strip(metricData[i].factoryName) + '</td>';
							}
							htmlContent +=
								'</tr>';
						} else {
							htmlContent +=
								'<tr>' +
								'<td style="padding:4px" colspan="' + columnCount + '">' +
								(totalRecords - 10) + ' values not shown</td>' +
								'</tr>';
							break;
						}
					}
					htmlContent +=
						'</table>';
				}
			}
			$scope.rawDataTooltip = $sce.trustAsHtml(htmlContent);
		};
		
		function getFactoryNdxByHierarchy(hierarchyType, hierarchyValue) {
			if (globalConfig.user.role !== 'Supplier') {
				var factories, customerNdx = globalConfig.customer.id;
					
				factories = _.toArray(globalConfig.user.authFacts).filter(function(factory) {
					return factory.roleType !== 'Supplier' && factory.customerNdx === customerNdx && factory[hierarchyType.toLowerCase()] === hierarchyValue;
				});

				return factories.map(function(factory) {
					return factory.ndx;
				});
			} else {
				return [];
			}
		}
		$scope.showMetricComments = function (metricName, period, year, date, actual, goal, actualAllDecimals, goalAllDecimals) {
			if (!opened) {
				var qryParams = {};
				var factoryIdList = leanFilterService.getFactoryList();
				var businessUnitList = leanFilterService.getSelectedIds('businessunit');
				var vStreams = $scope.filterService.getSelected('Value Stream');
				vStreams = (!vStreams || !vStreams.length) ? '' : vStreams.toString();
				qryParams.vstreams = vStreams;
				var multiFactory = $scope.filterService.getSelected('Multi Factory');
				if (!multiFactory) {
					multiFactory = 'combinedOnly';
				}
				var row = {
					rawPeriod: $scope.formatPeriod(period, year, date, true),
					period: $scope.formatPeriod(period, year, date),
					name: metricName,
					actual: actual,
					goal: goal,
					actualAllDecimals: actualAllDecimals,
					goalAllDecimals: goalAllDecimals,
					metricResults: [],
					crossSiteName: crossSiteNameMap[metricName],
					factoryNdxs: factoryIdList.toString(),
					queryParams: jQuery.param(qryParams),
					isCrossSite: true,
					viewType: multiFactory
				};
				
				var isAllSitesCell = false;
				if (metricName in $scope.rawMetricResults) {
					row.metricResults = $scope.rawMetricResults[metricName][period];
				} else {
					var pos = metricName.indexOf('-All');
					if (metricName.length === pos + 4) {
						isAllSitesCell = true;
						var baseMetricName = metricName.substr(0, pos);
						for (metricName in $scope.rawMetricResults) {
							if ($scope.rawMetricResults.hasOwnProperty(metricName) &&
								$scope.rawMetricResults[metricName].hasOwnProperty(period) &&
								metricName.indexOf(baseMetricName) === 0) {
								row.metricResults = row.metricResults.concat($scope.rawMetricResults[metricName][period]);
							}
						}
					}
				}
				
				if (row.metricResults && row.metricResults.length) {
					row.showValueStream = false;
					if (!isAllSitesCell) {
						if (row.viewType === 'site') {
							row.factoryNdxs = row.metricResults[0].leanDirFactoryNdx;
							if (businessUnitList.length >= 1 || factoryIdList.length > 1) {
								row.isCrossSite = true;
							} else {
								row.isCrossSite = false;
							}
						}
						row.metricName = row.name.replace('-' + row.metricResults[0].factoryName, '');
					} else if (isAllSitesCell && row.viewType === 'site') {
						row.isCrossSite = true;
						row.factoryNdxs = $scope.filterService.getSelected('Factory');
					} 
					if (row.viewType === 'businessUnit' || row.viewType === 'division' || row.viewType === 'entity') {
						row.isCrossSite = true;
						var factoryNdxs = getFactoryNdxByHierarchy(row.viewType, row.name.replace(crossSiteNameMap[metricName] + '-', ''));
						if (factoryNdxs && factoryNdxs.length) {
							row.factoryNdxs = factoryNdxs;
						}
					}
					row.showSite = $scope.filterService.getSelected('Factory').length > 1 &&
						(multiFactory !== 'site' ||
							isAllSitesCell);
					// Reset the metric results to make sure no stale data is being passed to slidein
					row.metricResults = [];
					getDataForSlidein(row);
				}
				
			}
		};

		function getTable() {
			$scope.showLinks = true;
			$scope.loadingData = true;
			if ($scope.filterService.getSelected('Factory').length > 1) {
				$scope.showLinks = false;
			}

			return controlTowerService.getControlTowerData()
				.then(function (data) {
					jQuery('div.tooltip').remove();
					if (data) {
						var ctData = data;
						$scope.showIndFact = false;
						var i;

						if (data && data.length && data.length > 1) {
							$scope.categoryLabel = 'Metric';
							$scope.currencySymbol = ctData[0].currencySymbol;
							$scope.currency = ctData[0].currency;
							$scope.startDate = ctData[0].startTimestamp;
							$scope.endDate = ctData[0].endTimestamp;
							ctData = organizeCTData(ctData);
							$scope.showIndFact = true;
							$scope.showLinks = true;
							if ($scope.filterService.getSelected('Multi Factory') !== 'site') {
								$scope.showLinks = false;
							}
							$scope.metricLabel = 'Site';
						} else {
							$scope.categoryLabel = 'Category';
							$scope.currencySymbol = ctData.currencySymbol;
							$scope.startDate = ctData.startTimestamp;
							$scope.endDate = ctData.endTimestamp;
							// escape html in metric names
							for (i = 0; i < ctData.metrics.length; i++) {
								var met = ctData.metrics[i];
								met.name = met.name;
							}
						}

						$scope.metrics = ctData.metrics;
						$scope.metricValues = [];
						// escape html in metric names in the results
						for (i = 0; i < ctData.metricValues.length; i++) {
							var monthData = ctData.metricValues[i];
							var decodedData = {};
							for (var metricName in monthData) {
								if (monthData.hasOwnProperty(metricName)) {
									decodedData[metricName] = monthData[metricName];
								}
							}
							$scope.metricValues.push(decodedData);
						}
						$scope.startMonthOfYear = parseInt(ctData.startMonthOfYear);
						if ($scope.metrics.length < 1 || $scope.metricValues.length < 1) {
							$scope.empty = true;
						} else {
							$scope.empty = false;
						}
					}
					$scope.loadingData = false;
					if (!$scope.empty) {
						if ($scope.showIndFact) {
							formatData();
							$timeout(function () {
								$scope.resizeCT();
							}, 0);
						} else {
							init();
						}
					}
					if ($scope.metrics.length > 50) {
						$rootScope.$emit('toast', {
							message: 'Showing 50 out of ' + $scope.metrics.length + ' columns. Please refine your filters.',
							success: false,
							time: 5000
						});
					}

					$rootScope.title = 'LeanDNA Dashboard - Control Tower';
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
				});
		}

		updateEventBind($scope, ['controlTowerFilterChanged']);

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				$scope.type = $scope.filterService.getSelected('Control Tower Time Period');
				if (!$scope.type) {
					$scope.type = 'Current';
				}
				if (!$scope.type.endsWith('Weeks')) {
					$scope.type = 'Monthly';
				}
				getTable();
				getRawData();
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();

		function updateControlTowerByColumns() {
			var activeColumns = getActiveColumns();
			var colSpanLength = activeColumns.length;

			$scope.showAct = false;
			$scope.showDiff = false;
			$scope.showGoal = false;

			angular.forEach(activeColumns, function (col) {
				if (col.id == 'act') {
					$scope.showAct = true;
				} else if (col.id == 'diff') {
					$scope.showDiff = true;
				} else if (col.id == 'goal') {
					$scope.showGoal = true;
				}
			});

			$scope.colSpanLength = colSpanLength == 0 ? 1 : colSpanLength;
		}

		$scope.getColSpan = function(colspan) {
			return colspan * $scope.colSpanLength;
		};

		function toggleColumn(id) {
			angular.forEach($scope.columns, function (col) {
				if (col.id === id) {
					col.active = !col.active;
				}
			});
			if ($scope.modelDetails) {
				$scope.modelDetails.config.columns = $scope.columns;
			}

			config.columns = $scope.columns;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column0',
					position: 0,
					widget: {
						name: 'controlTower',
						config: _.cloneDeep(configStr)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});

			var categories = $scope.categories;
			$scope.categories = [];
			$scope.categories = categories;
			updateControlTowerByColumns();

			$timeout(function () {
				$scope.resizeCT();
				$scope.$apply();
			}, 0);
		};

		function getActiveColumns() {
			var activeColumns = [];
			angular.forEach($scope.columns, function (col) {
				if (col.active) {
					activeColumns.push(col);
				}
			});
			return activeColumns;
		}

		function setControlTowerDefaultColumns(configStr) {
			if (configStr.columns) {
				$scope.columns = configStr.columns;
			} else {
				$scope.columns = [
					{
						id: 'act',
						displayText: 'Act',
						active: true
					},
					{
						id: 'diff',
						displayText: 'Diff',
						active: false
					},
					{
						id: 'goal',
						displayText: 'Target',
						active: true
					}
				];
			}
		}

		function formatValue(response, result, fmtService, fieldName, rawFieldName) {
			if (typeof result[fieldName] !== undefined && result[fieldName] !== null) {
				var decimals = metricRoundingService.getDecimals(result);
				if (result.displayType === 'currency') {
					decimals = Math.max(decimals, 2);
					result[rawFieldName] = fmtService.getWithParametersNegativeSign(result[fieldName], decimals, response.currencySymbol);
					result[fieldName] = fmtService.get(result[fieldName], response.currencySymbol);
				} else if (result.displayType === 'percentage') {
					result[rawFieldName] = fmtService.getWithParameters(result[fieldName], decimals);
					result[fieldName] = fmtService.get(result[fieldName]);
				} else {
					result[rawFieldName] = fmtService.getWithParameters(result[fieldName], decimals, true);
					result[fieldName] = fmtService.get(result[fieldName]);
				}
			}
		}

		function getDataForSlidein(row) {
			if (!opened) {
				opened = true;
				var qryParams = {};
				var factoryIdList = row.factoryNdxs || globalConfig.factory.id;
				var vStreams = leanFilterService.getSelectedIds('valueStream');
				vStreams = (!vStreams || !vStreams.length || vStreams.toString() === 'LDNA_A_S') ? '' : vStreams.toString();
				qryParams.vstreams = vStreams;
				qryParams.dateString = row.rawPeriod;
				var metricNdx = _.replace(row.crossSiteName, /\//g, '');
				qryParams.currency = $scope.currency;
				qryParams.crossSiteName = row.crossSiteName;
				qryParams.displayPeriod = $scope.type === 'Monthly' ? 'Monthly': 'Weekly';
				qryParams.frequency = $scope.filterService.getSelected('Frequency');
				if(!metricNdx) {
					return;
				}
				var rawMetricData;
				controlTowerService.getUnaggregatedRawMetricResults(factoryIdList.toString(), encodeURIComponent(metricNdx), qryParams).then(function (response) {
					rawMetricData = response;
					if (rawMetricData && rawMetricData.results) {
						row.showValueAB = rawMetricData.results[0].valueFunction === 'value' ? false : true;
						row.metricResults = [];
						var metricName = null;
						angular.forEach(rawMetricData.results, function (result) {
							var tmp = {};
							tmp.unformattedValue = result.value;
							tmp.unformattedValueA = result.valueA;
							tmp.unformattedValueB = result.valueB;
							if (metricName == null) {
								metricName = result.name;
							} else if (!row.showMetricName) {
								if (result.name !== metricName) {
									row.showMetricName = true;
									row.extraColumnCount++;
								}
							}
							// format the value
							var fmtService = serviceMap[result.displayType];
							if (fmtService) {
								formatValue(response, result, fmtService, 'value', 'rawValue');
								formatValue(response, result, fmtService, 'valueA', 'rawValueA');
								formatValue(response, result, fmtService, 'valueB', 'rawValueB');
							}
							tmp.actualDate = $filter('date')(result.currentDate, 'MMM dd', 'UTC');
							tmp.date = tmp.actualDate;
							tmp.value = result.value;
							tmp.valueA = result.valueA;
							tmp.valueB = result.valueB;
							tmp.metricName = result.name;
							tmp.category = result.category;
							tmp.rawValue = result.rawValue;
							tmp.rawValueA = result.rawValueA;
							tmp.rawValueB = result.rawValueB;
							tmp.valueStream = result.valueStream;
							tmp.factoryName = result.factoryName;
							tmp.leanDirFactoryNdx = result.leanDirFactoryNdx;
							tmp.metricResultNdx = result.metricResultNdx;
							tmp.comment = result.comment;
							tmp.commentNdx = result.commentNdx;
							if (result.isCategorized) {
								tmp.category = result.category;
							}
							if (!row.showValueStream) {
								// could be UndefinedValueStream or UndefinedValuestream
								if (result.valueStream && result.valueStream.toUpperCase() !== 'UNDEFINEDVALUESTREAM') {
									row.showValueStream = true;
									row.extraColumnCount++;
								}
							}
							row.metricResults.push(tmp);
						});
						angular.forEach(rawMetricData.metricInactiveInterval, function (inactiveInterval) {
							var tmp = {};
							tmp.unformattedValue = 'N/A';
							var resultDate = new Date(inactiveInterval.endTimestamp);
							tmp.actualDate = $filter('date')(resultDate, 'MMM dd', 'UTC');
							tmp.date = tmp.actualDate;
							tmp.value = 'N/A';
							tmp.valueA = 'N/A';
							tmp.valueB = 'N/A';
							tmp.metricName = inactiveInterval.name;
							tmp.rawValue = tmp.value;
							tmp.rawValueA = tmp.valueA;
							tmp.rawValueB = tmp.valueB;
							tmp.valueStream = inactiveInterval.valueStream;
							tmp.factoryName = inactiveInterval.factoryName;
							tmp.leanDirFactoryNdx = inactiveInterval.leanDirFactoryNdx;
							tmp.metricResultNdx = null;
							tmp.comment = null;
							tmp.commentNdx = null;
							tmp.isInactive =  true;
							row.metricResults.push(tmp);
						});
					}
					var instance;
					$timeout(function () {
						instance = slideInModalService.openModal({
							templateUrl: '/application/f/dashboard/metric-comments-slide-in.html',
							windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html',
							controller: 'metricCommentSlideIn as metricCommentSlideInCtrl',
							resolve: {
								'row': function () {
									return row;
								}
							}
						});
						instance.result.then(function () {
							opened = false;
						});
						instance.result.catch(function() {
							jQuery('.inlineEditDiv').unbind();
							jQuery('.inlineEditDiv').remove();
							opened = false;
						});
					}, 0);
				}, function (e) {
					rawMetricData = undefined;
					opened = false;
				});
			}
		}
	})

	.directive('toggle', function () {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				if (attrs.toggle == 'tooltip') {
					$(element).tooltip();
				}
			}
		};
	});
